import { includes } from 'lodash';
import { IUserData } from '@app/models';
import { defaultOrgId } from '@app/helpers';
import { store } from '@app/helpers/store';
import { mainMenuTypes } from '@app/components/Sidebar/menuObject/menu.enum';
import { IMenuItem } from '@app/components/Sidebar/menuObject';
import { basicService } from '@app/services/basic.service';
import { Administrator } from '@app/store/constants';
import { localStore } from './domStorage.helper';

// Checks the user has any of the permission(s) for the active organization in the org filter
export function hasOrgPermission(args: string[]): boolean {
    const currentUser: any = store.getState().signIn.currentUser as IUserData;

    if (!currentUser || !currentUser.orgPermissions) {
        return false;
    }

    let org0: any = currentUser.orgPermissions[defaultOrgId];

    if (!!org0 && org0.length && org0.indexOf(Administrator) >= 0) {
        return true;
    }

    let permissions: string[] = [];

    if (args && args.length) {
        Array.prototype.slice.call(args).forEach(function (arg) {
            permissions.push(arg);
        });
    }

    let orgId: string = localStore.getItem('org_filter') || '';

    if (!orgId) {
        orgId = currentUser.oid;

        localStore.setItem('org_filter', orgId);
    }

    let perms: any = currentUser.orgPermissions;

    let hasPerm: boolean = false;

    Object.keys(perms).forEach(function (org) {
        if (org === orgId) {
            permissions.forEach(function (perm) {
                if (perms[org].indexOf(perm) >= 0) {
                    hasPerm = true;
                }
            });
        }
    });

    return hasPerm;
}

// Checks the user has the any of the permission(s) in at least one organization
export function hasPermission(args: string[]): boolean {
    const currentUser: any = store.getState().signIn.currentUser;

    let permissions: string[] = [];

    if (args && args.length) {
        Array.prototype.slice.call(args).forEach(function (arg) {
            permissions.push(arg);
        });
    }

    if (currentUser && currentUser.permissions && currentUser.permissions.length) {
        let foundPermission: number = 0;

        currentUser.permissions.forEach(function (currentPermission: string) {
            if (includes(permissions, currentPermission)) {
                foundPermission++;
            }
        });

        return foundPermission === permissions.length;
    }

    return false;
}

// Gets the permissions of the user for the vault being viewed
export function getActiveVaultPermission(vaultPermissions: any): Set<string> {
    let permissionSet = new Set<string>();
    if (!vaultPermissions) {
        return permissionSet;
    }

    vaultPermissions.forEach((perm: string) => permissionSet.add(perm));

    return permissionSet;
}

// Checks the user has the any of the permission(s) for a vault
export function hasVaultPermission(args: string[]): boolean {
    const currentUser: any = store.getState().signIn.currentUser;
    let permissions: string[] = [];

    if (args && args.length) {
        Array.prototype.slice.call(args).forEach(function (arg) {
            permissions.push(arg);
        });
    }

    if (currentUser && currentUser.vaultPermNames && currentUser.vaultPermNames.length) {
        let foundPermission: number = 0;

        currentUser.vaultPermNames.forEach(function (currentPermission: string) {
            if (includes(permissions, currentPermission)) {
                foundPermission++;
            }
        });

        return foundPermission === permissions.length;
    }

    return false;
}

export function hasFeature(args: string[]) {
    const currentUser: any = store.getState().signIn.currentUser;
    const shellConfig: any = store.getState().basic.shellConfig;

    let features: string[] = [];

    if (args && args.length) {
        Array.prototype.slice.call(args).forEach(function (arg) {
            features.push(arg);
        });
    }

    if (currentUser) {
        if (shellConfig && shellConfig.organizations && shellConfig.organizations.length) {
            let foundFeatures: number = 0;

            shellConfig.organizations.forEach(function (org: any) {
                if (org.id === currentUser.oid) {
                    org.license.features.forEach(function (currentFeature: string) {
                        if (includes(features, currentFeature)) {
                            foundFeatures++;
                        }
                    });
                }
            });
            return foundFeatures === features.length;
        }
    }
    return false;
}

export function hasMenuPermissionRoot(menuItem: IMenuItem): boolean {
    const shellConfig: any = store.getState().basic.shellConfig;

    if (menuItem.id === mainMenuTypes.PasswordVaults && basicService.isDefaultOrgBeta() && basicService.orgFeaturePasswordServerEnabled()) {
        return true;
    }

    for (let i = 0; i < shellConfig.apps.length; i++) {
        if (shellConfig.apps[i].appTitle === menuItem.matchedLabel) {
            return true;
        }
    }
    return false;
}

export function hasMenuPermissionChild(menuItem: IMenuItem): boolean {
    const shellConfig: any = store.getState().basic.shellConfig;

    for (let i = 0; i < shellConfig.apps.length; i++) {
        if (shellConfig.apps[i].navLinks) {
            for (let j = 0; j < shellConfig.apps[i].navLinks.length; j++) {
                if (shellConfig.apps[i].navLinks[j].label === menuItem.matchedLabel) {
                    return true;
                }
            }
        }
    }

    return false;
}

export function hasDefaultOrgAdminPermission(): boolean {
    const currentUser: any = store.getState().signIn.currentUser as IUserData;

    if (!currentUser || !currentUser.orgPermissions) {
        return false;
    }

    let org0: any = currentUser.orgPermissions[defaultOrgId];

    return !!org0 && org0.length && org0.indexOf(Administrator) >= 0;
}

export function isDefaultOrgUser(): boolean {
    const currentUser: any = store.getState().signIn.currentUser;

    return !(!currentUser || !currentUser.oid || currentUser.oid !== defaultOrgId);
}

export function isLoggedInToDefaultOrg(): boolean {
    const shell = store.getState().basic.shellConfig;
    return shell.intercom.isDefaultOrg;
}
